import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Analytics } from '@vercel/analytics/react';
import TagManager from 'react-gtm-module';

// Handle LiveAvatar "Session not found" before React overlay (SDK throws in Promise callback)
const onError = (event) => {
  const msg = (event?.error?.message || event?.message || '').toLowerCase();
  if (msg.includes('session not found')) {
    if (event.preventDefault) event.preventDefault();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    window.dispatchEvent(new CustomEvent('session-not-found'));
    return true;
  }
  return false;
};
window.addEventListener('error', onError, true);

const gtmId = process.env.REACT_APP_GTM_ID;
if (gtmId) {
  TagManager.initialize({ gtmId });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);
